import { createStyles, makeStyles } from '@material-ui/core';
import { LocalizationProvider } from '@material-ui/lab';
import DateAdapter from '@material-ui/lab/AdapterLuxon';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import BackdropLoader from 'src/components/loader/BackdropLoader';
import AppScrollTo from 'src/components/page/AppScrollTo';
import SiteLayout from 'src/components/site/SiteLayout';
import { useCustomErrorMap } from 'src/core/hooks/custom-error-map';
import LoaderProvider from 'src/core/hooks/loader';
import { useAppMeta } from 'src/core/provider/AppMeta';
import HomeRoutes from 'src/pages/HomeRoutes';
import Notifier from './core/Notifier';

const useSnackStyles = makeStyles(theme =>
    createStyles({
        root: { marginTop: theme.spacing(1) },
        variantSuccess: {
            backgroundColor: theme.palette.success.main,
            color: theme.palette.success.contrastText,
        },
        variantError: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.error.contrastText,
        },
        variantWarning: {
            backgroundColor: theme.palette.warning.main,
            color: theme.palette.warning.contrastText,
        },
        variantInfo: {
            backgroundColor: theme.palette.info.main,
            color: theme.palette.info.contrastText,
        },
    })
);

const App: React.FC = props => {
    const snackClasses = useSnackStyles();
    const { selectedLanguageKey, initialized } = useAppMeta();

    // Setup Custom Error Map for Zod errors
    useCustomErrorMap();

    return (
        <LocalizationProvider dateAdapter={DateAdapter} locale={selectedLanguageKey}>
            <LoaderProvider component={BackdropLoader}>
                <SnackbarProvider classes={snackClasses} maxSnack={10}>
                    <Notifier />
                    <AppScrollTo />
                    {initialized && (
                        <SiteLayout>
                            <HomeRoutes />
                        </SiteLayout>
                    )}
                </SnackbarProvider>
            </LoaderProvider>
        </LocalizationProvider>
    );
};

export default App;
